module.exports = __webpack_public_path__ + "img/cerita_tokotelagawarna.95dcdc02.png";